<template>
  <div>
    <v-divider class="mx-3" />
    <div class="userAnalysisContainer">
      <div class="pl-3">
        <div class="element-quote">
          <v-icon v-if="element.element" size="20">
            format_quote
          </v-icon>
          <v-icon v-if="element.comment" size="15">
            chat_bubble_outline
          </v-icon>
          {{ this.element.text }}
        </div>
        <p class="authored ma-0 ml-2 pt-1">
          <span v-if="element.comment">
            - {{ $t('views.analysis.commentBy') }}
          </span>
          <span v-if="element.element">
            - {{ $t('views.analysis.highlightBy') }}
          </span>
          {{ this.element.username }}
        </p>
      </div>
      <v-btn
        class="insertButton"
        fab
        elevation="0"
        @click.stop="insertElement"
      >
        <v-icon class="material-icon">
          add
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import * as analysisConstants from '@/store/analysisConstants';

export default {
  name: 'UserAnalysisElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  methods: {
    insertElement() {
      const blockData = {
        type: this.element.comment
          ? analysisConstants.ANALYSIS_REFLECTION_COMMENT : analysisConstants.ANALYSIS_SIGNIFICANT_ELEMENT,
        data: {
          ...this.element,
        },
      };
      this.$emit('insert-block', blockData);
    },
  },
};
</script>

<style scoped>
.userAnalysisContainer {
  padding: 12px;
  padding-left: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header {
  display: flex;
  flex-direction: row;
}

.element-quote {
  color: black;
}
.elementText {
  color: #6E6D7B;
}

.insertButton {
  width: 24px;
  height: 24px;
}

.insertButton .v-icon {
  font-size: 16px;
  font-weight: 600;
}
.authored {
  font-weight: 300;
  font-size: 11px;
  font-style: italic;
}
</style>
